<script setup>
    import { onMounted } from "vue"
    import { useAppStore, useSpaceStore, useDataCacheStore } from "~/stores"
    import { usePageTitle } from "~/composables"

    const appStore = useAppStore()
    const spaceStore = useSpaceStore()
    const dataCacheStore = useDataCacheStore()
    const { watchCompanyAndSetClientTitle } = usePageTitle()

    onMounted(async () => {
        await spaceStore.getClientDetail()
        await dataCacheStore.fetchDataCache()
        watchCompanyAndSetClientTitle()
    })
</script>

<template>
    <div>
        <SpaceHeader />
        <v-main class="pt-0">
            <v-progress-linear v-if="appStore.showLoading" indeterminate />
            <v-container>
                <router-view />
            </v-container>
        </v-main>
        <SpaceFooter :color="spaceStore.getColor" />
    </div>
</template>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
</style>
